var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"IM2leHprmQn-riwS93MGy"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { init } from '@flex-packages/sentry';
import getConfig from 'next/config';

const isServer = __FLEX_GLOBAL_CONFIG__.NEXT_IS_SERVER;
const isProductionBuild = __FLEX_GLOBAL_CONFIG__.IS_PRODUCTION_BUILD;

init({
  isProductionBuild,
  isServer,
  dsn: getConfig().publicRuntimeConfig.SENTRY_DSN,
  release: getConfig().publicRuntimeConfig.NEXT_PUBLIC_SENTRY_RELEASE,
  environment: getConfig().publicRuntimeConfig.STAGE,
});
